import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[numericOnly]',
})
export class NumericOnly {
  @HostListener('beforeinput', ['$event'])
  onBeforeInput(event: InputEvent) {
    if (!event.data) {
      return;
    }

    const isNumber = /^[0-9]+$/.test(event.data);

    if (!isNumber) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    const isNumber = /^[0-9]+$/.test(pastedText);

    if (!isNumber) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const droppedText = event.dataTransfer?.getData('text') ?? '';
    const isNumber = /^[0-9]+$/.test(droppedText);

    if (!isNumber) {
      event.preventDefault();
    }
  }
}
